function join(...parts: string[]) {
  return parts
    .map((part, index) => {
      if (index === 0) {
        return part.replace(/\/+$/, '')
      }
      return part.replace(/^\/+|\/+$/g, '')
    })
    .join('/')
}

const DEFAULT_URL = 'http://127.0.0.1'

export function buildUrl(
  endpoint: string,
  path: string,
  searchParams: Record<string, string | number> = {}
) {
  try {
    const url = new URL(endpoint)
    url.pathname = join(url.pathname, path)
    Object.entries(searchParams).forEach(([key, value]) =>
      url.searchParams.append(key, value.toString())
    )
    return url.toString()
  } catch {
    const url = new URL(endpoint, DEFAULT_URL)
    url.pathname = join(url.pathname, path)
    Object.entries(searchParams).forEach(([key, value]) =>
      url.searchParams.append(key, value.toString())
    )
    return url.toString().replace(DEFAULT_URL, '')
  }
}
